import React from 'react';
import PropTypes from 'prop-types';
import { classNamesPrefixed } from '../../../helpers/CoreHelpers';

export const Icon = (props) => {
    const { name, className, value, type } = props;

    if (!name) {
        return null;
    }

    const iconClasses = classNamesPrefixed({
        [type]: true,
        ['fa-' + name]: true,
        [className]: true
    });

    return (
        <i className={iconClasses} value={value}></i>
    );
};

Icon.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
};

Icon.defaultProps = {
    name: undefined,
    className: undefined,
    value: undefined,
    type: "fa"
};


// WEBPACK FOOTER //
// ./src/core/admin/components/UI/Icon.js